/* Dansk katalog for locale-autopilot-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'ap.monthControl.edit.supplierInvoice': 'Ret leverandørfaktura',
  'ap.monthControl.edit.fallbackWithLabel': 'Ret {{label}}',
  'ap.monthControl.edit.fallback': 'Ret',
  'ap.monthControl.vatAmount': 'Moms {{amount}}',
  'ap.monthControl.vatAmountWithRate': 'Moms {{amount}} ({{rate}} %)',
  'ap.monthControl.vatAmountMissing': 'Momsbeløb ikke fundet ({{rate}} %)',
  'ap.monthControl.invoiceNumber': 'Faktura {{number}}',
  'ap.monthControl.linkedBankLineAmount': 'banklinje {{amount}}',
  'ap.monthControl.reopenNote': 'Banklinjen er genåbnet. Kontrollér og godkend igen for at bogføre.',
  'ap.monthControl.reopenSuccess': 'Banklinjen er genåbnet',
  'ap.monthControl.reopenError': 'Kunne ikke genåbne banklinjen.',
  'ap.monthControl.reopenMatchSuccess': 'Koblingen er genåbnet. Den oprindelige post er ikke ændret.',
  'ap.monthControl.reopenMatchError': 'Kunne ikke genåbne koblingen.',
  'ap.monthControl.moreMenu.trigger': 'Andet',
  'ap.monthControl.moreMenu.close': 'Luk menu',
  'ap.monthControl.choice.asset': 'Aktiv',
  'ap.monthControl.contact.customerLabel': 'Kunden',
  'ap.monthControl.contact.supplierLabel': 'Leverandøren',
  'ap.monthControl.contact.requiredBeforeApprove': '{{contact}} skal gemmes, før linjen kan godkendes.',
  'ap.monthControl.action.reopen': 'Genåbn',
  'ap.monthControl.action.correct': 'Ret',
  'ap.monthControl.action.reverse': 'Tilbagefør',
  'ap.monthControl.action.approve': 'Godkend',
  'ap.monthControl.asset.reconciledNote': 'Afstemt mod registreret aktiv: {{description}}',
  'ap.monthControl.asset.linkedSuccess': 'Aktivet er koblet til banklinjen',
  'ap.monthControl.asset.linkError': 'Aktivet blev gemt, men banklinjen kunne ikke kobles.',
  'ap.monthControl.receipt.fallbackName': 'Bilag',
  'ap.monthControl.receipt.view': 'Vis bilag',
  'ap.monthControl.receipt.duplicateNote': '{{label}}. Godkend koblingen for at færdiggøre banklinjen uden ny bogføring.',
  'ap.monthControl.receipt.detachTitle': 'Fjerner kun koblingen. Bilaget lægges tilbage i indbakken.',
  'ap.monthControl.receipt.detach': 'Frakobl',
  'ap.monthControl.receipt.rowLabel': 'Bilag {{number}}',
  'ap.monthControl.contact.supplierNameRequired': 'Leverandørnavn skal udfyldes.',
  'ap.monthControl.contact.customerNameRequired': 'Kundenavn skal udfyldes.',
  'ap.monthControl.contact.supplierRegistryUnavailable': 'Leverandørregistret er ikke tilgængeligt.',
  'ap.monthControl.contact.customerRegistryUnavailable': 'Kunderegistret er ikke tilgængeligt.',
  'ap.monthControl.contact.supplierSaved': 'Leverandøren er gemt.',
  'ap.monthControl.contact.customerSaved': 'Kunden er gemt.',
  'ap.monthControl.contact.supplierSaveError': 'Kunne ikke gemme leverandøren.',
  'ap.monthControl.contact.customerSaveError': 'Kunne ikke gemme kunden.',
  'ap.monthControl.contact.updateSupplierTitle': 'Opdatér leverandør',
  'ap.monthControl.contact.newSupplierTitle': 'Ny leverandør',
  'ap.monthControl.contact.editCustomerTitle': 'Redigér kunde',
  'ap.monthControl.contact.newCustomerTitle': 'Ny kunde',
  'ap.monthControl.contact.saving': 'Gemmer...',
  'ap.monthControl.contact.update': 'Opdatér',
  'ap.monthControl.contact.save': 'Gem',
  'ap.monthControl.contact.saved': 'Gemt',
  'ap.monthControl.contact.archived': 'Arkiveret',
  'ap.monthControl.contact.notSavedOptional': 'Ikke gemt · valgfrit',
  'ap.monthControl.contact.edit': 'ret',
  'ap.monthControl.contact.add': 'Tilføj',
  'ap.monthControl.contact.saveSupplier': 'Gem leverandør',
  'ap.monthControl.summary.stick': 'Fastgør topkortet, når du scroller',
  'ap.monthControl.summary.unstick': 'Frigør topkortet',
  'ap.monthControl.summary.expand': 'Vis hele topkortet',
  'ap.monthControl.summary.collapse': 'Minimér topkortet',
  'ap.monthControl.summary.opening': 'Primo',
  'ap.monthControl.summary.closing': 'Ultimo',
  'ap.monthControl.summary.deviation': 'Afvigelse',
  'ap.monthControl.summary.remaining': 'Tilbage',
  'ap.monthControl.summary.bankLines': 'Banklinjer',
  'ap.monthControl.summary.allHandled': 'Alle håndteret',
  'ap.monthControl.summary.remainingLinesOne': '{{count}} linje',
  'ap.monthControl.summary.remainingLinesMany': '{{count}} linjer',
  'ap.whatShouldDo': 'Hvad skal SuperPlumma gøre?',
  'ap.openBankingHelp': 'SuperPlumma henter dine banktransaktioner automatisk via en sikker bankforbindelse (Open Banking) og kobler dem til bilag. Uden forbindelse skal du uploade kontoudtog manuelt.',
  'ap.dataExists': 'Data findes',
  'ap.notConnected': 'Ikke tilsluttet',
  'ap.switchBank': 'Skift bank',
  'ap.connectBank': 'Tilslut bank',
  'ap.monthPickerHelp': 'Vælg, hvilken måned du vil arbejde med. Listen viser kun arbejde, der hører til den måned. Grønt flueben betyder, at intet står tilbage; rødt betyder, at måneden er passeret med noget ugjort.',
  'ap.monthOverview': 'Månedsoversigt',
  'ap.prevMonth': 'Forrige måned',
  'ap.nextMonth': 'Næste måned',
  'ap.noActiveAgents': 'Ingen aktive agenter',
  'ap.activateAgents': 'Aktivér agenter',
  'ap.monthSummaryHelp': 'Arbejde for den valgte måned og opfølgning, der gælder hele året.',
  'ap.agents': 'Agenter',
  'ap.agentCount': '{{count}} agent',
  'ap.agentCountPlural': '{{count}} agenter',
  'ap.totalTasksHelp': 'Antal agenter, du faktisk finder på listen nedenfor. Agenter, der har kontrolleret og ikke fundet noget, er ikke med.',
  'ap.readyForApproval': 'Til kontrol',
  'ap.readyForApprovalHelp': 'Opgaver, der venter på dig — enten fordi noget skal kontrolleres, eller fordi gennemgangen mangler en signatur. De er ikke udført, før du har set på dem.',
  'ap.approvedHelp': 'Opgaver, der er kontrolleret eller godkendt. En godkendt kontrol betyder ikke, at noget er bogført, sendt eller indberettet. Se status og detaljer på opgaven.',
  'ap.approveAllHelp': 'Godkender de enkelte forslag, som AI Bogholder har vurderet som klar — ikke måneden. Bogføringen sker bagefter med en særskilt Bogfør-knap.',
  'ap.approveAllGreen': 'Godkend klare',
  'ap.approveProposals': 'Godkend {{count}} forslag',
  'ap.approveAndBookProposals': 'Godkend og bogfør {{count}} forslag',
  'ap.book': 'Bogfør {{count}} forslag',
  'ap.bookHelp': 'Fører de godkendte forslag ind i regnskabet. Det er den eneste knap, der ændrer tallene, og den kan ikke fortrydes med et klik.',
  'ap.nothingToCheck': 'Intet at kontrollere',
  'ap.autoApproved': 'Ingen kontrolpunkter',
  'ap.autoApprovedDetail': 'Intet at kontrollere',
  'ap.agent.beforeBank.title': 'Bankafstemningen starter senere end {{month}}',
  'ap.agent.beforeBank.desc': 'Bankkontoen har primosaldo {{date}}, og Plumme afstemmer fra dagen efter.',
  'ap.agent.beforeBank.descNoDate': 'Bankkontoen afstemmes først fra en senere dato.',
  'ap.agent.beforeBank.detail': 'Datoen står på bankkontoen i Indstillinger. Skal Plumme også afstemme denne måned, skal startdatoen sættes tidligere, og kontoudtoget uploades i Bank.',
  'ap.agent.beforeBank.action': 'Åbn bank',
  'ap.monthImported': 'Ført i et andet system',
  'ap.monthOverdue': 'En frist i denne måned er overskredet',
  'ap.monthReviewHint': 'Ikke færdig — noget står tilbage i måneden',
  'ap.monthReviewed': '{{month}} er gennemgået',
  'ap.agent.imported.title': '{{month}} er ført i et andet system',
  'ap.agent.imported.desc': 'Regnskabet blev overtaget senere. AI Bogholder har ikke kontrolleret denne måned.',
  'ap.agent.imported.detail': 'Tal og bilag for perioden ligger i importarkivet. De skal kontrolleres mod det gamle system, ikke mod Plumme.',
  'ap.agent.imported.action': 'Åbn arkivet',
  'ap.agent.invoice.titleEmpty': 'Ingen fakturaer i {{year}}',
  'ap.agent.invoice.descEmpty': 'Der er ikke registreret fakturaer i Plumme for perioden, så der er intet at kontrollere.',
  'ap.agent.quality.titleEmpty': 'Ingen køb i {{year}}',
  'ap.agent.quality.descEmpty': 'Der er ikke registreret køb i Plumme for perioden, så der er intet at kontrollere.',
  'ap.agent.match.titleEmpty': 'Ingen banklinjer i {{year}}',
  'ap.agent.match.descEmpty': 'Intet kontoudtog dækker perioden, så der er intet at koble.',
  'ap.agent.inbox.detailHistoric': '{{count}} af bilagene er dateret, før regnskabet blev overtaget. De er sandsynligvis allerede bogført i det gamle system og bogføres ikke herfra — de skal kobles som dokumentation.',
  'ap.agent.dunning.detailImported': '{{count}} af posterne kommer fra regnskabsimporten og ligger ikke i fakturalisten. Plumme kan hverken sende dem eller sende rykkere — de skal følges op i det gamle system eller registreres som afregnet her.',
  'ap.agent.dunning.lineImported': 'Fra regnskabsimporten · faktura {{num}} · kan ikke rykkes fra Plumme',
  'ap.agent.dunning.importedParty': 'Kunde fra importen',
  'ap.require.noEmployees': 'Der er ikke registreret aktive medarbejdere.',
  'ap.require.noVat': 'Virksomheden er ikke momsregistreret.',
  'ap.yearScope': 'Gælder hele året',
  'ap.yearScopeHelp': 'Arbejde, der ikke hører til én måned — forfaldne krav, frister, registre og årsafslutning.',
  'ap.showAllYearTasks': 'Vis alle ({{count}})',
  'ap.showFewerYearTasks': 'Vis færre',
  'ap.monthEmpty': 'Intet står tilbage i {{month}}.',
  'ap.agent.reconcile.titleMonth': '{{month}} er ikke afstemt',
  'ap.agent.reconcile.titleMonthDone': '{{month}} er afstemt',
  'ap.agent.reconcile.titleMonthOpen': '{{month}} er ikke afsluttet endnu',
  'ap.agent.reconcile.descMonth': 'Driftskontoens kontoudtog for {{month}} er ikke bogført og arkiveret i Bank.',
  'ap.agent.reconcile.descMonthDone': 'Driftskontoens kontoudtog for {{month}} er bogført og arkiveret.',
  'ap.agent.reconcile.descMonthOpen': 'Måneden afstemmes, når den er afsluttet, og kontoudtoget er importeret.',
  'ap.agent.reconcile.waitingReason': 'Venter på månedsafslutning',
  'ap.agent.match.titleWaiting': '{{month}} er ikke afsluttet endnu',
  'ap.agent.match.descWaiting': 'Bilagsagenten starter bankkontrollen, når måneden er afsluttet, og kontoudtoget kan importeres.',
  'ap.agent.match.detailWaiting': 'Der mangler endnu ikke noget kontoudtog. Opgaven bliver aktuel efter månedsafslutningen.',
  'ap.agent.payroll.titleWaiting': 'Løn for {{period}} afventer',
  'ap.agent.payroll.descWaiting': 'Perioden er ikke begyndt endnu. Lønagenten følger op, når måneden er aktuel.',
  'ap.agent.payroll.waitingReason': 'Venter på, at perioden starter',
  'ap.agent.payroll.titleReady': 'Lønkørsel for {{period}} kan oprettes',
  'ap.agent.payroll.descReady': 'Faste lønlinjer er klar til at blive oprettet som en kladde til kontrol.',
  'ap.agent.reconcile.disabledTitle': 'Afstemning er ikke aktiv',
  'ap.agent.reconcile.disabledDesc': 'Ingen aktive bankkonti er sat op til afstemning.',
  'ap.agent.reconcile.disabledDetail': 'Det passer til virksomheder, der bruger en privat konto og har valgt, at kontoen ikke skal afstemmes i Bank.',
  'ap.agent.match.disabledTitle': 'Bilagsmatch er ikke aktiv',
  'ap.agent.match.disabledDesc': 'Ingen aktive bankkonti er sat op til afstemning.',
  'ap.agent.match.disabledDetail': 'Når virksomheden bruger en privat konto uden bankafstemning, findes der intet driftskontoudtog at koble bilag til.',
  'ap.showDetails': 'Vis detaljer',
  'ap.showTask': 'Vis opgave',
  'ap.quiet.title': '{{count}} agenter fandt intet at kontrollere',
  'ap.quiet.titleClear': '{{count}} agenter fandt intet at følge op på',
  'ap.quiet.titleOne': '{{agent}} fandt intet at kontrollere',
  'ap.quiet.titleClearOne': '{{agent}} fandt intet at følge op på',
  'ap.quiet.someApproved': '{{count}} godkendt',
  'ap.require.noBankReconciliation': 'Ingen aktive bankkonti er sat op til afstemning.',
  'ap.agent.awaitBank.title': 'Venter på kontoudtog for {{month}}',
  'ap.agent.awaitBank.desc': 'Upload kontoudtoget for perioden. Uden det findes der ingen banklinjer at koble bilag til eller afstemme.',
  'ap.agent.awaitBank.detail': 'Bankarbejdet sker i rækkefølge: kontoudtoget skal ind, før bilagene kan kobles, og måneden kan afstemmes.',
  'ap.agent.awaitBank.action': 'Åbn bank',
  'ap.agent.awaitBank.reason': 'Mangler kontoudtog for perioden',
  'ap.uploadStatement': 'Upload kontoudtog',
  'ap.agent.awaitBank.descAccounts': '{{count}} konti mangler kontoudtog for perioden.',
  'ap.agent.awaitBank.reasonAccounts': 'Mangler kontoudtog på {{count}} konti',
  'ap.agent.awaitBank.account': 'Bankkonto',
  'ap.taskColumnHelp': 'Hvad SuperPlumma har gjort — f.eks. bogført banktransaktioner, koblet bilag, registreret aktiver eller kørt løn.',
  'ap.task': 'Opgave',
  'ap.descriptionColumn': 'Beskrivelse',
  'ap.statusColumn': 'Status',
  'ap.actionColumn': 'Handling',
  'ap.statusColumnHelp': 'Grøn betyder ajour. Gul betyder, at noget bør kontrolleres, før du går videre. Tjek de markerede linjer.',
  'ap.actionColumnHelp': 'Tryk på «Vis» for at se grundlaget bag opgaven, eller «Åbn» for at gå til siden, hvor du kan arbejde videre.',
  'ap.task.actionLabel': 'Gå til',
  'ap.task.detailsLabel': 'Se detaljer',
  'ap.agent.bank.disabledTitle': 'Bankafstemning er ikke aktiv',
  'ap.agent.bank.disabledDesc': 'Ingen aktive bankkonti er sat op til afstemning.',
  'ap.agent.bank.disabledDetail': 'Det passer til virksomheder, der bruger en privat konto og har valgt, at kontoen ikke skal afstemmes i Bank.',
  'ap.agent.bank.action': 'Åbn bank',
  'ap.agent.bank.reopenDetail': 'Genåbn afstemningen, hvis noget skal rettes. Så vises bankarbejdsfladen i samme vindue.',
  'ap.agent.bank.title': 'Bankafstemning: {{count}} linjer skal kontrolleres',
  'ap.agent.bank.titleNoStatement': 'Bankafstemningen mangler kontoudtog',
  'ap.agent.bank.desc': '{{handled}} linjer er behandlet, {{remaining}} står tilbage.',
  'ap.agent.bank.descNoStatement': 'Importér et kontoudtog, før AI Bogholder kan foreslå bankafstemning.',
  'ap.agent.bank.detail': 'AI Bogholder viser banklinjer, der ikke er færdigafstemt. Selve bogføringen skal stadig godkendes i bankvisningen.',
  'ap.agent.bank.detailNoStatement': 'Der er ikke noget kontoudtog tilgængeligt for perioden.',
  'ap.agent.bank.actionImport': 'Importér bank',
  'ap.agent.bank.blockedReason': 'Mangler bankdata',
  'ap.agent.bank.archiveLabel': 'Arkivér {{count}} færdige kontoudtog',
  'ap.agent.bank.archiveConfirmTitle': 'Arkivér færdigbehandlede kontoudtog',
  'ap.agent.bank.archiveConfirmWarn': 'Kontoudtogene flyttes til arkivet og låser perioden. De kan genåbnes fra Bank.',
  'ap.agent.bank.archiveCheckedNote': 'Kun kontoudtog, hvor alle linjer er behandlet, alt er bogført, og saldoen stemmer. Alt andet skal du gøre fra «Afstem og bogfør».',
  'ap.agent.bank.archiveDoneLabel': 'kontoudtog arkiveret',
  'ap.agent.vat.termWithNumber': 'periode {{n}}',
  'ap.agent.vat.termFallback': 'momsperioden',
  'ap.agent.vat.termWithPeriod': 'Moms {{period}}',
  'ap.agent.vat.termGeneric': 'Momsperiode',
  'ap.agent.vat.disabledTitle': 'Momsagenten er ikke aktiv',
  'ap.agent.vat.disabledDesc': 'Virksomheden står ikke som momsregistreret i indstillingerne.',
  'ap.agent.vat.disabledDetail': 'AI Bogholder viser ikke momsindberetning, før virksomheden er momsregistreret.',
  'ap.agent.vat.noTermTitle': 'Ingen momsperiode i denne måned',
  'ap.agent.vat.noTermDesc': 'Virksomhedens momsperiode har ingen indberetning knyttet til den valgte måned.',
  'ap.agent.vat.noTermDetail': 'Fristagenten giver stadig besked, når momsfristen nærmer sig. Selve momsperioden ligger under Indberetninger.',
  'ap.agent.vat.openFilings': 'Åbn indberetninger',
  'ap.agent.vat.titleOverdueOne': '{{count}} momsperiode har overskredet fristen',
  'ap.agent.vat.titleOverdueMany': '{{count}} momsperioder har overskredet fristen',
  'ap.agent.vat.titleCandidatesOne': '{{count}} momsperiode skal indberettes',
  'ap.agent.vat.titleCandidatesMany': '{{count}} momsperioder skal indberettes',
  'ap.agent.vat.titleWaiting': 'Moms {{term}} er ikke færdig endnu',
  'ap.agent.vat.titleUpToDate': 'Momsen er ajour',
  'ap.agent.vat.descCandidates': 'Momstallene er beregnet ud fra regnskabet og skal kontrolleres før indberetning.',
  'ap.agent.vat.descWaiting': 'Perioden dækker {{period}} og har frist {{due}}.',
  'ap.agent.vat.descDelivered': 'MVA-meldingen er indberettet. Den vises stadig her, så du kan åbne perioden, hvis noget skal rettes.',
  'ap.agent.vat.descNoneOpen': 'Ingen åbne momsperioder fundet.',
  'ap.agent.vat.detail': 'AI Bogholder bruger momstallene i Plumme. Indberetning og betaling skal stadig godkendes, før noget sendes.',
  'ap.agent.vat.dueNote': 'Frist {{due}}',
  'ap.agent.vat.paidNote': 'Indberettet og betalt',
  'ap.agent.vat.filedNote': 'Indberettet',
  'ap.agent.asset.title': 'Vurdér {{count}} køb som aktiv',
  'ap.agent.asset.titleEmpty': 'Ingen aktivforslag',
  'ap.agent.asset.desc': 'Køb bogført på aktivkonto mangler i aktivregistret.',
  'ap.agent.asset.descEmpty': 'Ingen køb i perioden skal vurderes.',
  'ap.agent.asset.detail': 'Registrerede aktiver følges op i aktivregistret og i årsafslutningen.',
  'ap.agent.asset.action': 'Åbn aktiver',
  'ap.agent.asset.registerLabel': 'Registrér {{count}} driftsmidler',
  'ap.agent.asset.registerConfirmTitle': 'Registrér driftsmidler',
  'ap.agent.asset.registerConfirmWarn': 'Købene får et afskrivningsgrundlag. Beløb, dato, konto og moms på selve købet ændres ikke.',
  'ap.agent.asset.registerCheckedNote': 'Kun køb, hvor kontoen bestemmer saldogruppen, registreres. Er gruppen uklar, skal du selv vælge — forkert gruppe giver forkert afskrivningssats i alle fremtidige år.',
  'ap.agent.asset.registerDoneLabel': 'driftsmidler registreret',
  'ap.agent.asset.lineFallback': 'Køb',
  'ap.agent.payroll.titleOpenOne': '{{count}} lønkørsel venter',
  'ap.agent.payroll.titleOpenMany': '{{count}} lønkørsler venter',
  'ap.agent.payroll.titleNoRuns': 'Løn har ingen åbne kørsler',
  'ap.agent.payroll.descOpen': 'Lønnen skal kontrolleres og godkendes i lønvisningen.',
  'ap.agent.payroll.descApprovedOne': '{{count}} lønkørsel er godkendt eller betalt.',
  'ap.agent.payroll.descApprovedMany': '{{count}} lønkørsler er godkendt eller betalt.',
  'ap.agent.payroll.detail': 'AI Bogholder viser lønstatus fra Plumme. Godkendelse og betaling sker i lønvisningen. Indsendelse af A-melding til Altinn er ikke tilsluttet endnu.',
  'ap.agent.payroll.action': 'Åbn løn',
  'ap.agent.payroll.lineFallback': 'Lønkørsel',
  'ap.agent.payroll.generateLabel': 'Opret lønkørsel for {{period}}',
  'ap.agent.payroll.generateConfirmTitle': 'Opret lønkørsel som kladde',
  'ap.agent.payroll.generateConfirmWarn': 'Kørslen oprettes som kladde ud fra faste lønlinjer. Intet udbetales eller bogføres — du skal åbne løn, kontrollere hver medarbejder og selv godkende.',
  'ap.agent.payroll.generateCheckedNote': 'Rejserefusioner medtages ikke. De skal tilføjes manuelt, så ingen refusion udbetales, uden at rejsen er vurderet.',
  'ap.agent.payroll.generateDoneLabel': 'lønkørsel oprettet',
  'ap.workspace.doneCount': '{{count}} godkendt',
  'ap.workspace.doneNone': 'Ingen godkendt endnu',
  'ap.workspace.readyCountOne': '{{count}} er klar',
  'ap.workspace.readyCountMany': '{{count}} er klar',
  'ap.workspace.inboxReviewCount': '{{count}} linjer skal kontrolleres',
  'ap.workspace.remainingCount': '{{count}} tilbage',
  'ap.workspace.reviewToControl': '{{count}} til kontrol',
  'ap.workspace.assetDetail': 'Det samme bilag ejes af bogføringskøen. Vælg udgiftsføring eller driftsmiddel her; købet bogføres kun én gang.',
  'ap.workspace.queueDetail': 'Forslagene er samlet pr. agent. Åbn listen for at kontrollere og redigere før godkendelse.',
  'ap.workspace.openWorklist': 'Åbn arbejdsliste',
  'ap.workspace.proposalModalTitle': 'Kontrollér forslag · {{title}}',
  'ap.workspace.close': 'Luk',
  'ap.workspace.saveProposal': 'Gem forslag',
  'ap.workspace.proposalSaveNote': 'At gemme ændrer forslaget, ikke regnskabet. En tidligere godkendelse ophæves, når forslaget ændres.',
  'ap.workspace.accountLabel': 'Konto',
  'ap.workspace.vatRateLabel': 'Momssats',
  'ap.workspace.paidWithLabel': 'Betalt med',
  'ap.workspace.paidWithCompany': 'Firmakonto',
  'ap.workspace.paidWithPrivate': 'Privat',
  'ap.workspace.paidWithCash': 'Kontant',
  'ap.workspace.needsReviewOption': 'Skal kontrolleres',
  'ap.workspace.treatmentLabel': 'Behandling',
  'ap.workspace.treatmentPlaceholder': 'Vælg behandling',
  'ap.workspace.treatmentExpense': 'Udgiftsfør hele købet',
  'ap.workspace.treatmentAsset': 'Registrér som driftsmiddel',
  'ap.workspace.balanceGroupLabel': 'Saldogruppe',
  'ap.workspace.balanceGroupPlaceholder': 'Vælg saldogruppe',
  'ap.workspace.balanceGroupA': 'a · kontormaskiner mv. (30 %)',
  'ap.workspace.balanceGroupC': 'c · varebiler mv. (24 %)',
  'ap.workspace.balanceGroupD': 'd · inventar mv. (20 %)',
  'ap.workspace.typeLabel': 'Type',
  'ap.workspace.bookingTypePurchase': 'Køb',
  'ap.workspace.bookingTypeSale': 'Salg',
  'ap.workspace.bookingTypeUnknown': 'Skal behandles i Bank',
  'ap.workspace.classificationLabel': 'Klassificering',
  'ap.workspace.classificationBusiness': 'Firma',
  'ap.workspace.mileageModalTitle': 'Redigér kørsel',
  'ap.workspace.saveTrip': 'Gem tur',
  'ap.workspace.dateLabel': 'Dato',
  'ap.workspace.purposeLabel': 'Formål',
  'ap.workspace.fromLabel': 'Fra',
  'ap.workspace.toLabel': 'Til',
  'ap.workspace.kilometersLabel': 'Kilometer',
  'ap.suggestionOverrideNote': 'Du kan ændre konto, moms og beløb, før du godkender. Ændringen tilsidesætter autopilotens forslag.',
  'ap.payslipFor': 'Lønseddel for {{name}}',
  'ap.payslipEditHelpHourly': 'Hurtig rettelse: justér beløb eller antal timer. Resten af lønsedlen beregnes igen.',
  'ap.payslipEditHelpFixed': 'Hurtig rettelse: justér beløb. Resten af lønsedlen beregnes igen.',
  'ap.payslipBookedHelp': 'SuperPlumma har bogført lønnen på 5000, forskudsskat på 2600 og arbejdsgiverafgift på 2770.',
  'ap.payslipCalculatedGross': 'Beregnet bruttoløn:',
  'ap.payslipHourlyLabel': 'Timeløn',
  'ap.payslipFixedLabel': 'Fast løn',
  'ap.contactsNewSuppliersTitle': 'Nye leverandører',
  'ap.contactsCreateSelected': 'Opret valgte ({{count}})',
  'ap.contactsProposedCount': '{{count}} {{noun}} foreslået',
  'ap.contactsFoundNote': 'SuperPlumma fandt posteringer uden registreret {{noun}}. Gem dem i {{list}}, så fremtidige posteringer knyttes automatisk.',
  'ap.contactsInclude': 'Medtag',
  'ap.openingVoucher': 'Åbner {{name}}',
  'ap.sendReminder': 'Send påmindelse',
  'ap.sendInvoice': 'Send faktura',
  'ap.clickToSeePayslipLines': 'Klik for at se lønlinjer',
  'ap.clickToEditProposal': 'Klik for at redigere forslaget',
  'ap.clickToOpenWorkArea': 'Klik for at åbne arbejdsområdet',
  'ap.ignoreThisMonth': 'Ignorer denne måned',
  'ap.entryCancelled': 'Posteringen blev annulleret',
  'ap.entryUpdated': 'Postering opdateret 🟣',
  'ap.approvalReopened': 'Godkendelsen er ophævet. Opgaven er åben igen.',
  'ap.reopenTaskError': 'Kunne ikke genåbne opgaven.',
  'ap.proposalsBookedToast': '{{count}} forslag er godkendt og bogført.',
  'ap.approveBookError': 'Kunne ikke godkende og bogføre forslagene.',
  'ap.proposalUpdatedToast': 'Forslaget er opdateret og skal godkendes igen.',
  'ap.lineHiddenToast': 'Linjen er skjult for denne måned og kommer tilbage næste måned, hvis den stadig er åben.',
  'ap.voucherLinkedToast': 'Bilaget er knyttet til banklinjen. Forslaget vurderes igen.',
  'ap.mileageFillRequired': 'Udfyld dato, fra, til, formål og kilometer.',
  'ap.mileageSaveUnavailable': 'Det er ikke muligt at gemme kørebogen.',
  'ap.mileageUpdatedToast': 'Kørslen er opdateret.',
  'ap.noActiveAgentsText': 'SuperPlumma står klar, men ingen agenter er aktiveret lige nu. Aktivér de agenter, du vil bruge, i indstillingerne ovenfor, så går teamet i gang med dit regnskab.',
  'ap.vatSurface.emptyTitle': 'Ingen momsperiode at indberette',
  'ap.vatSurface.emptyDesc': 'Alle perioder i året står som indberettet.',
  'ap.vatSurface.pickPrompt': 'Vælg, hvilken momsperiode du vil kontrollere og indsende.',
  'ap.vatSurface.termFallback': 'Momsperiode',
  'ap.vatSurface.title': 'MVA-melding',
  'ap.vatSurface.openSubmissions': 'Åbn indberetninger',
});
